var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('span',{on:{"click":_vm.toggleOptions}},[(_vm.username)?_c('span',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.username)))]):_vm._e(),(!_vm.username)?_c('span',[_vm._v("Guest")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }